import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Valence } from '@upright/common/model/types';
import { TargetsLensData } from '../types';

export function isTargetsDataAreaClickable(data: TargetsLensData, impact: ImpactCategoryId, valence: Valence): boolean {
  const items = data.targets;
  if (!items) {
    return false;
  }
  return !!items.find(t => t.impactCategoryId === impact && t.valence === valence);
}
